export default "__VITE_ASSET__Bh7vsN7N__"